module.exports = "\r\n  <router-outlet>\r\n      \r\n</router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.html
// module id = ./src/app/app.html
// module chunks = main